export interface PromptTemplate {
  id: string;
  label: string;
  content: string;
}

// Shown when a project is in context. Every one of these says "this project", so they only make
// sense while the panel has a projectId to forward.
export const PROJECT_PROMPT_TEMPLATES: PromptTemplate[] = [
  {
    id: "reduce-carbon",
    label: "Reduce carbon",
    content: "Show three alternatives to reduce the carbon assessment for this project.",
  },
  {
    id: "project-impact",
    label: "List project impact",
    content: "List the key environmental impacts of this project.",
  },
  {
    id: "quality-check",
    label: "QA check project",
    content: "Check the quality of my project and perform a basic QA.",
  },
];

// Shown when the AI Agent is opened outside a project — from the AI Agent Skills page, the project
// list, the library. The starters above would ask it about a project it hasn't been given,
// so these cover what it can actually answer without one: platform questions from the docs
// connection, and library work (RTLCA-4891).
export const GENERAL_PROMPT_TEMPLATES: PromptTemplate[] = [
  {
    id: "compare-materials",
    label: "Compare two materials",
    content: "Compare the climate impact of two materials from the library.",
  },
  {
    id: "explain-term",
    label: "Explain a term",
    content: "Explain what GWP is and which lifecycle stages it covers.",
  },
  {
    id: "how-to",
    label: "How do I get started?",
    content: "How do I set up a new project and get to a first result?",
  },
];
